import moment from 'moment';

const MAX_REPS = 24;
export const getNextPaymentDate = (original: string) => {
  const today = moment();
  const og = moment.utc(original);

  let rep = 0;
  while (og.isSameOrBefore(today, 'day') && rep < MAX_REPS) {
    rep += 1;
    og.add(1, 'month');
  }

  return og;
};
